import { api } from "../../../../../api";
import { PlatformList } from "./FormSuccess.types";

export const getPlatform = async (): Promise<PlatformList[]> => {
  return api.get("/platform").then((response): PlatformList[] => response.data);
};
